<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates47">
<p class="centerImage"><img alt="images" id="plate47" src="images/plate47.jpg"/></p>
<p class="caption">The 50th Anniversary of the Battle of Britain, 605 Squadron re-unite for this picture, in a Birmingham hotel: Front: Archie Milne, Alex Ingle, Gerry Edge, John Fleming, Peter Parrott. Rear: Bunny Currant, Ken Jones, RWF, Mike Cooper-Slipper.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates47.vue?5c35cccb